import {add, format} from 'date-fns';
import {ColumnFieldEnum, KPIColumnEnum} from 'interfaces';
import {getSupportedLocale} from './locale';

export const dateReader = (date: string | Date) => {
  if (typeof date === 'object') {
    return date;
  }
  if (date.includes('T') || date.includes(':') || date.includes('+')) {
    return new Date(date);
  }
  return new Date(`${date}T00:00`);
};

export const isValidDate = (date: Date | null): boolean => {
  return date instanceof Date && !isNaN(date.getTime());
};

export const localDateSender = (date: Date | null): string => {
  if (date && date.toString() !== 'Invalid Date') {
    return format(date, 'yyyy-MM-dd');
  } else {
    return '';
  }
};

export const incrementDateString = (dateString: string, days: number) => {
  return localDateSender(add(dateReader(dateString), {days}));
};

export const roundTwoDecimals = (number: number) => Math.round(number * 100) / 100;
const roundThreeDecimals = (number: number) => Math.round(number * 1000) / 1000;

const oneThousand = 1000;
export const gramsToKilos = (grams: number) => grams / oneThousand;
export const kilosToGrams = (kilos: number) => kilos * oneThousand;
export const kilosToTons = (kilos: number) => kilos / oneThousand;
export const tonsToKilos = (kilos: number) => kilos * oneThousand;
export const tonsToGrams = (kilos: number) => kilos * 1000000;

export function Humanize(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function Transform(string: string, compareString: string) {
  const length = compareString.length - string.length;
  const _lengt = length > 0 ? length : 1;
  return Humanize(string).concat(' '.repeat(2 * _lengt));
}

export function addDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export const numberDisplay = (x: number | undefined | null, precision?: number | undefined): string => {
  if (x === undefined || x === null) {
    return '';
  }

  return x.toLocaleString(getSupportedLocale(), {minimumFractionDigits: precision, maximumFractionDigits: precision});
};

export const offsetDate = (date: Date, offset: number) => new Date(date.setDate(date.getDate() + offset));

export function formatData(field: string, value: number) {
  switch (field) {
    case ColumnFieldEnum.biomass:
      return kilosToTons(value);
    case ColumnFieldEnum.producedBiomass:
      return kilosToTons(value);
    case KPIColumnEnum.harvestVolumeLwe:
      return kilosToTons(value);
    case KPIColumnEnum.harvestVolumeHog:
      return kilosToTons(value);
    case KPIColumnEnum.averageHarvestWeight:
      return kilosToGrams(value);
    case ColumnFieldEnum.weight:
      return kilosToGrams(value);
    case ColumnFieldEnum.MAB:
      return kilosToTons(value);
    case ColumnFieldEnum.MABUtilization:
      return value * 100;
    case ColumnFieldEnum.count:
      return Math.round(value);
    case KPIColumnEnum.harvestCount:
      return Math.round(value);
    case KPIColumnEnum.feedAmount:
      return kilosToTons(value);
    default:
      return value;
  }
}

export const precise = (value: number, precision = 0) => {
  return parseFloat(value.toFixed(precision));
};

export const adjustmentHandler = (adjustment?: number) => {
  return Math.round(100 * ((adjustment ?? 1) - 1));
};

export const adjustmentSender = (adjunsment?: number) => {
  return (100 + (adjunsment ?? 0)) / 100;
};

const accumulatedMortalityRateHandler = (accumulatedMortalityRate: number) => {
  return Math.round(accumulatedMortalityRate * 100);
};

const accumulatedMortalityRateHandlerSender = (accumulatedMortalityRate: number) => {
  return accumulatedMortalityRate / 100;
};

function fishSpeciesHandlerNorwegian(species: string) {
  const lowerCaseSpecies = species.toLowerCase();

  if (lowerCaseSpecies === 'ørret') {
    return 'trout';
  }

  if (lowerCaseSpecies === 'laks') {
    return 'salmon';
  }

  return lowerCaseSpecies;
}
